import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useAllTaskStore } from './task'
import { useCanvasStore } from './canvas'
import { useFloorplanStore } from '../data/Editor/floorplan'

export const useEditorStore = defineStore('app-editor', () => {
  const review = ref(false)
  const shapeView = ref(false)
  function setReview(value: boolean): void {
    review.value = value
  }

  function setShapeView(value: boolean): void {
    shapeView.value = value
  }

  return {
    review,
    setReview,
    shapeView,
    setShapeView,
  }
})

export const useAppEditorFacilityStore = defineStore('app-editor-facility', () => {
  const selectedFacilityName = ref('')
  const selectedFloorName = ref('')
  const selectedFacilityDatabaseId = ref('')
  const selectedFloorDatabaseId = ref('')

  function selectFloor(floorDatabaseId: string): void {
    const allTaskStore = useAllTaskStore()
    if (allTaskStore.isNotLoaded()) {
      throw new Error('EditorTaskStore is not loaded')
    }

    const canvasStore = useCanvasStore()
    const floorplanStore = useFloorplanStore()
    canvasStore.clearSystemLayer()
    selectedFloorDatabaseId.value = floorDatabaseId
    selectedFloorName.value = floorplanStore.getFloorplanName(floorDatabaseId)
  }

  function selectFacility(facilityDatabaseId: string): void {
    if (facilityDatabaseId == '') {
      selectedFacilityDatabaseId.value = ''
      selectedFacilityName.value = ''
      return
    }
    const allTaskStore = useAllTaskStore()
    if (allTaskStore.isNotLoaded()) {
      throw new Error('EditorTaskStore is not loaded')
    }

    selectedFacilityDatabaseId.value = facilityDatabaseId
    selectedFacilityName.value = allTaskStore.getFacilityName(facilityDatabaseId)
  }

  function clearSelection(): void {
    selectedFacilityDatabaseId.value = ''
    selectedFacilityName.value = ''
    selectedFloorDatabaseId.value = ''
    selectedFloorName.value = ''
  }
  return {
    selectedFacilityName,
    selectedFloorName,
    selectedFacilityDatabaseId,
    selectedFloorDatabaseId,
    selectFloor,
    selectFacility,
    clearSelection,
  }
})
